import moment from "moment";
import ActionButton from "./ActionButton";
import Select from "./Select";

const TaskItem = ({ task }) => {
  const { id, taskName, teamMember, project, status, deadline } = task || {};
  const { name, avatar } = teamMember || {};
  const { projectName, colorClass } = project || {};

  return (
    <div className="lws-task">
      <div className="flex items-center gap-2 text-slate">
        <h2 className="lws-date">{moment(deadline).date()}</h2>
        <h4 className="lws-month">{moment(deadline).format("MMMM YYYY")}</h4>
      </div>

      <div className="lws-taskContainer">
        <h1 className="lws-task-title">{taskName}</h1>
        <span className={`lws-task-badge ${colorClass}`}>{projectName}</span>
      </div>

      <div className="flex items-center gap-4">
        <div className="flex items-center gap-2">
          <img src={avatar} className="team-avater" alt={name} />
          <p className="lws-task-assignedOn">{name}</p>
        </div>

        <ActionButton id={id} status={status} />

        <Select id={id} status={status} />
      </div>
    </div>
  );
};

export default TaskItem;
